<ng-container>
    <!-- AuthLayout -->
    <app-auth-layout *ngIf="AuthLayout"></app-auth-layout>

    <!-- MenuLayout -->
    <app-menu-layout *ngIf="MenuLayout"></app-menu-layout>
</ng-container>
